import classes from "./index.module.scss";
import { v4 as uuid } from "uuid";

export default function Text({ text, className }) {
  return (
    <div className={`${classes.text} ${className ? className : ""}`}>
      {text.map((p) => (
        <p key={uuid()}>{p}</p>
      ))}
    </div>
  );
}
